import Swiper from "swiper";
import { A11y, EffectFade, Navigation, Pagination } from "swiper/modules";
import "@styles/components/slider.css";

import measurements from "@components/measurements";

measurements.init();

document.querySelectorAll(".results-slider").forEach((el) => {
  const container = el.querySelector(".swiper");
  const numSlides = el.querySelectorAll(".result-slide").length;

  if (numSlides > 1) {
    new Swiper(container, {
      modules: [A11y, EffectFade, Navigation, Pagination],
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
      },
      pagination: {
        el: el.querySelector(".slider-pagination"),
        clickable: true,
      },
    });
  }
});
